import React from 'react'

import Entry from './Entry'

type OrderEntriesProps = {
  products: Array<any>
  returnedProducts?: Array<any>
  isTargetApp: boolean
}

const OrderEntries: React.FC<OrderEntriesProps> = ({
  products = [],
  returnedProducts = [],
  isTargetApp = false,
}) => (
  <ul>
    {products.map((product) => (
      <Entry key={`product${product.reference}`} product={product} isTargetApp={isTargetApp} />
    ))}
    {returnedProducts.map((product) => (
      <Entry
        key={`returnedProduct${product.reference}`}
        product={product}
        returned
        isTargetApp={isTargetApp}
      />
    ))}
  </ul>
)

export default OrderEntries
